import { Navigate, Outlet } from 'react-router-dom';
// Remove useAuth import
// import { useAuth } from '@/context/AuthContext';
import { useAppSelector } from '@/store/hooks'; // Import typed selector
import { selectIsAuthenticated, selectAuthLoaded, selectUserProfileDetails } from '@/store/slices/authSlice'; // Import selectors
import type { RootState } from '@/store'; // Import RootState for explicit typing

const ProtectedRoute = () => {
    // Get auth state from Redux store
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const authLoaded = useAppSelector(selectAuthLoaded);
    const userProfileDetails = useAppSelector(selectUserProfileDetails);
    const hasUsername = !!userProfileDetails?.username;
    const loading = useAppSelector((state: RootState) => state.auth.loading === 'pending' || state.auth.loading === 'initializing'); // Explicitly type state

    // If auth check hasn't finished yet OR is actively pending, show loading
    // Use authLoaded flag and loading status
    if (!authLoaded || loading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="animate-spin h-8 w-8 border-4 border-primary rounded-full border-t-transparent"></div>
                <span className="ml-3 text-foreground">Verifying authentication...</span>
            </div>
        );
    }

    // Auth is loaded but user is not authenticated - redirect to login (OpeningPage)
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // User is authenticated, but doesn't have a username yet - redirect to create-username
    if (!hasUsername) {
        return <Navigate to="/create-username" replace />;
    }
    
    // User is authenticated and has a username - allow access
    return <Outlet />;
};

export default ProtectedRoute;
